import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { withProcessingLogic } from "../../../../../../utils/utils.domain";
import { getSumInKopeiki } from "../../../PaymentSelection/components/PaymentDetailsSection/InputSection/components/SumInput/selectors";
export var initializeUseCase = function initializeUseCase(_ref) {
  var initializeQRCode = _ref.initializeQRCode,
    initializeSBPBanks = _ref.initializeSBPBanks;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(state, setState) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return withProcessingLogic(setState)(initializeQRCode({
              amount: getSumInKopeiki(state),
              ctn: state.phoneInput.value
            }));
          case 2:
            if (initializeSBPBanks) {
              _context.next = 4;
              break;
            }
            return _context.abrupt("return");
          case 4:
            _context.next = 6;
            return withProcessingLogic(setState)(initializeSBPBanks());
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};